module.exports = __webpack_public_path__ + "img/stock6.47a17c6e.png";